import { HomeTeamView } from './types';

export const EMISIONES_TEAM = 'EMISIONES';
export const ADMIN_TEAM = 'ADMIN';

export const HOME_TEAM_VIEW_STORAGE_KEY = 'homeTeamView';

const VALID_HOME_TEAM_VIEWS: HomeTeamView[] = ['DEFAULT', 'EMISIONES', 'ADMIN'];

export function readStoredHomeTeamView(): HomeTeamView {
	const stored = localStorage.getItem(HOME_TEAM_VIEW_STORAGE_KEY);
	if (stored && VALID_HOME_TEAM_VIEWS.includes(stored as HomeTeamView)) {
		return stored as HomeTeamView;
	}
	return 'DEFAULT';
}

export function persistHomeTeamView(view: HomeTeamView): void {
	localStorage.setItem(HOME_TEAM_VIEW_STORAGE_KEY, view);
}
